import PickupSessionGroupIndex from './PickupSessionGroupIndex';
import PickupSessionGroupCreate from './PickupSessionGroupCreate';
import PickupSessionGroupSettings from './PickupSessionGroupSettings';
import PickupSessionGroupSingle from './PickupSessionGroupSingle';

export default function (app) {

    const settings = PickupSessionGroupSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 9,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    PickupSessionGroupIndex(app, settings);

    PickupSessionGroupCreate(app, settings);

    PickupSessionGroupSingle(app, settings);

}